import Component from '../inherited/Component'
import rivets from 'rivets'
import Helpers from '../lib/Helpers'
import AjaxApi from '../lib/AjaxApi'

class Cart extends Component {
    constructor (elem, theme, options, ctx) {
        super(elem, theme, options, ctx)
        this._data = {
            main: {}
        }
        this._jsonElem = this._elem.querySelector('[data-free-gift-json]')
        this._renderArea = this._elem.querySelector('[data-free-gift-render]')
        this._popupTriggerContainers = document.querySelectorAll('[data-free-gift-popup-trigger-container]')
        this._isAddingItem = false
    }

    _binders () {
        rivets.formatters.eq = (item1, item2) => {
            return item1 == item2
        }

        rivets.formatters.flip = (item1) => {
            return !item1
        }

        rivets.formatters.getVariantTitle = (variant) => {
            return !variant.isSoldOut ? variant.title : `${variant.title} - Sold Out`
        }

        rivets.formatters.gt = (item1, item2) => {
            return item1 > item2
        }

        rivets.formatters.length = (arr) => {
            return arr ? arr.length : 0
        }
    }

    async mount () {
        await this._refresh()
        this._binders()
        this._render()

        document.addEventListener('click', e => {
            if (e.target.hasAttribute('data-free-gift-popup-trigger')) {
                e.preventDefault()
                this._data.main.popupOpen = true
            }
        })

        document.addEventListener('theme:loading:end', async e => {
            await this._refresh()
        })

        setInterval(() => {
            this._hideOrShowBanner()
        }, 300)
    }

    _hideOrShowBanner () { 
        this._popupTriggerContainers = document.querySelectorAll('[data-free-gift-popup-trigger-container]')

        if (this._shouldShowBanner()) {
            for (let trigger of this._popupTriggerContainers) {
                trigger.classList.add('shown')
            }
        } else {
            for (let trigger of this._popupTriggerContainers) {
                trigger.classList.remove('shown')
            }
        }
    }

    async prepareData (data) {
        data.cart = await AjaxApi.getCart()
        data.haveAddedFreeGift = false

        let inStockProducts = []

        for (let item of data.items) {
            item.inCart = data.cart.items.filter(cartItem => cartItem.product_id === item.productID && cartItem.properties && this._isGiftItem(cartItem)).length > 0

            if (item.inCart) {
                data.haveAddedFreeGift = true
            }

            for (let variant of item.variants) {
                variant.isSoldOut = variant.inventory_quantity <= data.variantOOSThreshold
            }

            for (let variant of item.variants) {
                if (!variant.isSoldOut) {
                    item.currentVariantID = variant.id
                    break
                }
            }

            if (item.variants.some(variant => !variant.isSoldOut)) {
                inStockProducts.push(item)
            }
        }

        data.cartThresholdReached = data.cart.total_price >= (data.threshold * 100.00)

        data.items = inStockProducts

        console.log(data)

        return data
    }

    async _refresh () {
        this._data.main = await this.prepareData(JSON.parse(this._jsonElem.innerHTML))

        this._hideOrShowBanner()

        if (this._shouldRemoveGift()) {
            for (let item of this._data.main.cart.items) {
                if (this._isGiftItem(item)) {
                    await AjaxApi.removeCartItem(item.variant_id)

                    document.dispatchEvent(new CustomEvent("product:added", {
                        bubbles: !0,
                        detail: {
                            variant: item.variant_id,
                            quantity: 0
                        }
                    }));

                    this._refresh()
                }
            }
        }
    }

    _isGiftItem (item) {
        return item.properties["_is-free-item"] === 'Yes'
    }

    _shouldShowBanner () {
        return !this._data.main.haveAddedFreeGift && this._data.main.cartThresholdReached && this._data.main.customerValid
    }

    _shouldRemoveGift () {
        return (!this._data.main.cartThresholdReached && this._data.main.haveAddedFreeGift) || !this._data.main.customerValid
    }

    _render () {
        rivets.bind(this._renderArea, this._getModel())
    }

    _getModel () {
        return {
            data: this._data,
            controller: {
                closePopup: async (e, model) => {
                    e.preventDefault()
                    this._data.main.popupOpen = false
                },
                closePopupOuter: async (e, model) => {
                    e.preventDefault()
                    if (e.target === this._renderArea) {
                        this._data.main.popupOpen = false
                    }
                },
                addFreeGift: async (e, model) => {
                    e.preventDefault()
                    
                    if (this._isAddingItem) return false
                    this._isAddingItem = true

                    let product = model.product
                    product.isAdding = true

                    await AjaxApi.addToCart({
                        id: product.currentVariantID,
                        quantity: 1,
                        properties: {
                            "_is-free-item": "Yes"
                        }
                    })

                    document.dispatchEvent(new CustomEvent("product:added", {
                        bubbles: !0,
                        detail: {
                            variant: product.currentVariantID,
                            quantity: 1
                        }
                    }));

                    window.location.reload()

                    // product.isAdding = false
                    // this._data.main.popupOpen = false

                    // this._refresh()
                }
            } 
        }
    }
}

export default Cart
